export default "__VITE_ASSET__83e8dcb1__"